import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/components/index'], resolve)
    },
    {
      path: '/Summary',
      name: 'Summary',
      component: resolve => require(['@/components/Summary'], resolve)
    },
    {
      path: '/Guide',
      name: 'Guide',
      component: resolve => require(['@/components/Guide'], resolve)
    },
    {
      path: '/Dictionary',
      name: 'Dictionary',
      component: resolve => require(['@/components/Dictionary'], resolve)
    },
    {
      path: '/Company/:id',
      name: 'Company',
      component: resolve => require(['@/components/Company'], resolve)
    }, 
    {
      path: '/Providers',
      name: 'Providers',
      component: resolve => require(['@/components/Providers'], resolve)
    }, {
      path: '/Copyright',
      name: 'Copyright',
      component: resolve => require(['@/components/Copyright'], resolve)
    }, {
      path: '/Organization',
      name: 'Organization',
      component: resolve => require(['@/components/Organization'], resolve)
    }, {
      path: '/Contact',
      name: 'Contact',
      component: resolve => require(['@/components/Contact'], resolve)
    },
    //english
    {
      path: '/English',
      name: 'English',
      component: resolve => require(['@/components/English'], resolve)
    },
    {
      path: '/SummaryEn',
      name: 'SummaryEn',
      component: resolve => require(['@/components/SummaryEn'], resolve)
    },
    {
      path: '/GuideEn',
      name: 'GuideEn',
      component: resolve => require(['@/components/GuideEn'], resolve)
    },
    {
      path: '/DictionaryEn',
      name: 'DictionaryEn',
      component: resolve => require(['@/components/DictionaryEn'], resolve)
    },
    {
      path: '/CompanyEn/:id',
      name: 'CompanyEn',
      component: resolve => require(['@/components/CompanyEn'], resolve)
    }, 
    {
      path: '/ProvidersEn',
      name: 'ProvidersEn',
      component: resolve => require(['@/components/ProvidersEn'], resolve)
    }, {
      path: '/CopyrightEn',
      name: 'CopyrightEn',
      component: resolve => require(['@/components/CopyrightEn'], resolve)
    }, {
      path: '/OrganizationEn',
      name: 'OrganizationEn',
      component: resolve => require(['@/components/OrganizationEn'], resolve)
    }, {
      path: '/ContactEn',
      name: 'ContactEn',
      component: resolve => require(['@/components/ContactEn'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js